<template>
  <div class="app-container">
    <div class="screeBox">
      <el-select
        filterable
        class="screenInput"
        v-model="screen.park_id"
        placeholder="请选择园区"
        v-if="userInfo.park_id == 0"
      >
        <el-option label="全部园区" value=""></el-option>
        <el-option
          :label="item.name"
          :value="item.id"
          v-for="(item, index) in parkList"
          :key="index"
        ></el-option>
      </el-select>
      <el-select
        filterable
        class="screenInput"
        v-model="screen.system_admin_id"
        placeholder="请选择后台回复人员"
      >
        <el-option label="全部人员" value=""></el-option>
        <el-option
          :label="item.username"
          :value="item.id"
          v-for="(item, index) in adminUserList"
          :key="index"
        ></el-option>
      </el-select>
      <el-select
        filterable
        class="screenInput"
        v-model="screen.user_id"
        placeholder="请选择评论者"
      >
        <el-option label="全部评论者" value=""></el-option>
        <el-option
          :label="item.name"
          :value="item.id"
          v-for="(item, index) in userList"
          :key="index"
        ></el-option>
      </el-select>
      <el-select
        filterable
        class="screenInput"
        v-model="screen.type"
        placeholder="请选择类型"
      >
        <el-option label="全部类型" value=""></el-option>
        <el-option label="用户评论" value="1"></el-option>
        <el-option label="物业回复" value="2"></el-option>
      </el-select>
      <el-select
        filterable
        class="screenInput"
        v-model="screen.object"
        placeholder="请选择关联对象"
      >
        <el-option label="全部关联对象" value=""></el-option>
        <el-option
          :label="item.name"
          :value="item.val"
          v-for="(item, index) in objectList"
          :key="index"
        ></el-option>
      </el-select>
      <el-select
        filterable
        class="screenInput"
        v-model="screen.star"
        placeholder="请选择星级"
      >
        <el-option label="全部类型" value=""></el-option>
        <el-option label="一星" value="1"></el-option>
        <el-option label="二星" value="2"></el-option>
        <el-option label="三星" value="3"></el-option>
        <el-option label="四星" value="4"></el-option>
        <el-option label="五星" value="5"></el-option>
      </el-select>
      <el-select
        class="screenInput"
        filterable
        v-model="screen.property_service_id"
        placeholder="请选择物业服务"
      >
        <el-option label="全部物业服务" value=""></el-option>
        <el-option
          :label="item.title"
          :value="item.id"
          v-for="(item, index) in propertyList"
          :key="index"
        ></el-option>
      </el-select>
      <el-input
        class="screenInput"
        v-model="screen.order_no"
        placeholder="请输入服务订单编号"
      ></el-input>
      <el-button type="primary" @click="(screen.page = 1), fetchData()" style="margin-bottom: 5px"
        >搜索</el-button
      >
      <el-button
        type="primary"
        plain
        @click="reset()"
        style="margin-bottom: 5px"
        >重置</el-button
      >
    </div>
    <el-table
      max-height="700"  v-loading="listLoading" 
      :header-cell-style="{ background: '#F2F3F5', color: '#606266' }"
      :data="list"
      element-loading-text="Loading"
      fit
      highlight-current-row
      stripe
      class="table-box"
      tooltip-effect="dark"
      row-key="id"
      :tree-props="{ children: 'nodes', hasChildren: 'hasChildren' }"
    >
      <el-table-column align="center" label="序号" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index + 1 }} -->
          {{ (screen.page - 1) * screen.page_size + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>

      <el-table-column label="所属园区" min-width="150">
        <template slot-scope="scope">
          <span>{{ scope.row.park ? scope.row.park.name : "" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="物业服务名称" min-width="210">
        <template slot-scope="scope">
          <div class="line2">
            {{
              scope.row.property_service ? scope.row.property_service.title : ""
            }}
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column label="封面图" width="150" align="center">
        <template slot-scope="scope">
          <el-image
            v-for="(img, ind) in scope.row.picurl.split(',')"
            :key="ind"
            style="width: 120px; height: 40px; margin: 0 5px 5px 0"
            :src="imageOss + img"
            fit="contain"
            :preview-src-list="$pathDispose(scope.row.picurl.split(','))"
          >
          </el-image>
        </template>
      </el-table-column> -->
      <!-- <el-table-column label="服务名称" min-width="110">
        <template slot-scope="scope">
          <div class="line2">
            {{ scope.row.snapshot ? scope.row.snapshot.title : "" }}
          </div>
        </template>
      </el-table-column> -->
      <el-table-column label="评论类型" width="150">
        <template slot-scope="scope">
          <span>{{
            scope.row.type == 1
              ? "用户评论"
              : scope.row.type == 2
              ? "物业回复"
              : ""
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="评论人" min-width="110">
        <template slot-scope="scope">
          <span>{{ scope.row.user ? scope.row.user.name : "" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="评论人手机号" min-width="130">
        <template slot-scope="scope">
          <span>{{ scope.row.user ? scope.row.user.phone : "" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="评论" width="150">
        <template slot-scope="scope">
          <div class="line2">{{ scope.row.details }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="操作" width="150" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="warning"
            @click="getInfo(scope.row.id)"
            v-if="roles.includes('/property/order_info')"
            >查看</el-button
          >
          <el-button
            size="mini"
            type="success"
            @click="reply(scope.row)"
            v-if="roles.includes('/property/comment_reply')"
            >回复</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="screen.page"
      :page-sizes="[15, 30, 50]"
      :page-size="screen.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="margin-top: 10px"
    >
    </el-pagination>

    <el-drawer size="700px" title="查看" :visible.sync="drawer" direction="rtl">
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-form-item label="所属园区" prop="park_id">
          <el-select
            filterable
            v-model="ruleForm.park_id"
            placeholder="请选择园区"
            disabled
          >
            <el-option
              :label="item.name"
              :value="item.id"
              v-for="(item, index) in parkList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="评论图片">
          <el-upload
            ref="upload"
            name="file[]"
            :data="{ type: 'image' }"
            :action="ossUpload"
            :file-list="fileList"
            list-type="picture-card"
            disabled
            accept=".jpg,.png,.jpeg"
            
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="评论内容">
          <el-input
            type="textarea"
            v-model="ruleForm.details"
            disabled
          ></el-input>
        </el-form-item>

        <div v-if="ruleForm.property_service">
          <el-form-item label="服务标题" prop="title">
            <el-input
              disabled
              v-model="ruleForm.property_service.title"
              placeholder="请输入标题"
            ></el-input>
          </el-form-item>
          <el-form-item label="服务图片">
            <el-upload
              ref="upload"
              name="file[]"
              :data="{ type: 'image' }"
              :action="ossUpload"
              :file-list="serviceFileList"
              list-type="picture-card"
              disabled
              accept=".jpg,.png,.jpeg"
              :class="serviceFileList.length > 0 ? 'hide' : ''"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="服务内容">
            <el-input
              type="textarea"
              v-model="ruleForm.property_service.des"
              disabled
            ></el-input>
          </el-form-item>
        </div>
      </el-form>
    </el-drawer>
    <el-dialog title="回复" :visible.sync="dialogVisible" width="500px">
      <el-form ref="replyForm" :model="replyForm" label-width="80px">
        <el-form-item prop="reason" label="回复内容">
          <el-input type="textarea" v-model="replyForm.details"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitForm('replyForm')"
            >确 定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { openPark, openAgoUser, adminUser } from "@/api/index";
import {
  comment_lists,
  comment_info,
  get_property_service_lists,
  comment_reply,
} from "@/api/property";
export default {
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl", "imageOss"]),
  },
  data() {
    return {
      screen: {
        page: 1,
        page_size: 15,
        park_id: "",
        pid: "",
        property_service_id: "",
        system_admin_id: "",
        user_id: "",
        star: "",
        object: "user,park,property_service,sub_info",
        type: 1,
        order_no: "",
      },
      objectList: [
        { name: "园区对象", val: "park" },
        { name: "回复人对象", val: "system_admin" },
        { name: "物业服务对象", val: "property_service" },
        { name: "物业服务订单对象", val: "property_service_order" },
        { name: "评论人对象", val: "user" },
        { name: "回复人的上级评论对象", val: "p_info" },
        { name: "评论人的下级回复对象", val: "sub_info" },
      ],
      parkList: [],
      userList: [],
      adminUserList: [],
      propertyList: [],
      listLoading: true,
      list: [],
      total: 0,
      drawer: false,
      ruleForm: {},
      ossUpload: this.$store.state.ossUpload,
      fileList: [],
      serviceFileList: [],
      replyForm: {
        details: "",
      },
      dialogVisible: false,
    };
  },
  created() {
    if (this.userInfo.park_id !== 0) {
      this.screen.park_id = this.userInfo.park_id;
      // this.getRole(this.userInfo.park_id);
    } else {
      // this.getCompany();
      this.screen.park_id = "";
    }
    this.fetchData();
    this.getPark();
  },
  methods: {
    submitForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确认提交？")
            .then(() => {
              comment_reply(that.replyForm).then((res) => {
                if (res.code === 200) {
                  this.$message({
                    message: res.msg,
                    type: "success",
                  });
                  that.dialogVisible = false;
                  that.fetchData();
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    // 评论回复
    reply() {
      var that = this;
      this.replyForm = {
        pid: that.commentInfo.comment.pid,
        property_service_id: that.commentInfo.comment.property_service_id,
        property_service_order_id:
          that.commentInfo.comment.property_service_order_id,
        park_id: that.commentInfo.comment.park_id,
        system_admin_id: this.userInfo ? this.userInfo.id : "",
        details: "",
      };
      this.dialogVisible = true;
      return;
      var that = this;
      const data = {
        id: id,
      };
      this.$confirm("确认取消订单？")
        .then((_) => {
          order_cancel(data).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
            } else {
            }
            that.fetchData();
          });
        })
        .catch((_) => {});
    },
    // 查看详情
    getInfo(id) {
      var that = this;
      let data = {
        id: id,
        object: "property_service",
      };
      comment_info(data).then((res) => {
        that.ruleForm = res.data.info;
        if (res.data.info.image) {
          that.fileList = [];
          let list = res.data.info.image.split(",");
          that.fileList = list.map((item) => {
            return {
              name: +new Date(),
              url: that.imageOss + item,
              response: {
                data: {
                  url: item,
                },
              },
            };
          });
        }
        if (res.data.info.property_service) {
          that.serviceFileList = [];
          let list = res.data.info.property_service.image.split(",");
          that.serviceFileList = list.map((item) => {
            return {
              name: +new Date(),
              url: that.imageOss + item,
              response: {
                data: {
                  url: item,
                },
              },
            };
          });
        }
        that.drawer = true;
      });
    },
    // 筛选园区选择
    parkChange(e) {
      this.screen.company_id = "";
      // this.getCompany(e);
    },
    // 获取园区
    getPark() {
      openPark({ is_page: 2, status: 1 }).then((res) => {
        this.parkList = res.data.lists;
      });
    },
    // 获取物业服务
    getProperty() {
      get_property_service_lists().then((res) => {
        this.propertyList = res.data.lists.data;
      });
    },
    // 获取用户列表
    getUser() {
      // var data = {
      //   park_id: this.screen.park_id,
      //   company_id: id,
      // };
      openAgoUser({is_youke:2}).then((response) => {
        this.userList = response.data.lists.data;
      });
    },
    // 获取后台用户列表
    getAdminUserList() {
      adminUser().then((response) => {
        this.adminUserList = response.data.lists.data;
      });
    },
    // 分页
    handleSizeChange(val) {
      this.screen.page_size = val;
      this.screen.page = 1;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.screen.page = val;
      this.fetchData();
    },
    // 重置
    reset() {
      this.screen = {
        page: 1,
        page_size: 15,
        park_id: "",
        pid: "",
        property_service_id: "",
        system_admin_id: "",
        user_id: "",
        star: "",
        object: "",
        type: "",
        order_no: "",
      };
      if (this.userInfo.park_id !== 0) {
        this.screen.park_id = this.userInfo.park_id;
      } else {
        this.screen.park_id = "";
      }
      this.fetchData();
    },
    // 获取列表
    fetchData() {
      this.listLoading = true;
      comment_lists(this.screen).then((response) => {
        this.list = response.data.lists.data;
        this.total = response.data.lists.total;
        this.listLoading = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.screeBox {
  border-bottom: 1px solid #e4e7ed;
  padding-bottom: 16px;
  .screenInput {
    width: 200px;
    margin-right: 10px;
    margin-bottom: 5px;
  }
}
.hide {
  ::v-deep .el-upload--picture-card {
    display: none;
  }
}
</style>
